import { humanReadableDateTime } from "../../../../../app/utils";
import { BackButton, LineSeperator } from "../../../../../components/RegularComponents";

const PenaltiesDescriptionDetails = ({ details, setDetails }) => {
  const handleGoBack = () => {
    setDetails(null);
  };

  return (
    <div
      className="licence-application-details-panel"
      style={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <div>
        <BackButton onClick={handleGoBack} />
        <div style={{ display: "flex", marginTop: 30 }}>
          <div style={{ width: 100, marginRight: 10 }}>
            <b>Date</b>
          </div>
          <div>{humanReadableDateTime(details?.createdDate)}</div>
        </div>
        <LineSeperator />

        <div style={{ display: "flex" }}>
          <div style={{ width: 100, marginRight: 10 }}>
            <b>Created by</b>
          </div>
          <div>{details?.createdBy}</div>
        </div>
        <LineSeperator />
      </div>
      <div>
        <b>{"Description"}</b>
      </div>
      <div
        style={{
          width: "100%",
          padding: 8,
          border: "2px solid #e8e8e8",
          flex: 1,
          marginBottom: 50
        }}
      >
        <div style={{ padding: "5px" }}>{details?.note}</div>
      </div>
    </div>
  );
};

export default PenaltiesDescriptionDetails;
